module.exports = __webpack_public_path__ + "static/img/otplatapozajmice1.c49fbdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/otplatapozajmice1.png
// module id = KhCV
// module chunks = 0